import React, { useEffect, useState } from "react";
import { Card, Box, Typography, Button, Fab } from "@material-ui/core";
import CreateIcon from "@mui/icons-material/Create";
import Avatar from "react-avatar";
import { useNavigate } from "react-router-dom";
import { DrawerItemsKey } from "../../constants/appConstants";
import { useDispatch } from "react-redux";
import { Endpoint, Status } from "../../apis/apiConstants";
import AjaxHelper from "../../apis/apiRequest";
import { startLoading, stopLoading } from "../../actions/loadingAction";
import placeholderBanner from "../../assets/Memon_NEWS.png";
import { errorSnackbar } from "../../actions/snackbarActions";
import "./news.scss";

const News = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [news, setNews] = useState([]);

  useEffect(() => {
    getNews();
  }, []);

  const getNews = () => {
    dispatch(startLoading);
    AjaxHelper.getApi(navigate, Endpoint.GET_NEWS)
      .then((response) => {
        dispatch(stopLoading);
        if (response.data.status === Status.API_SUCCESS) {
          console.log(response.data.data);
          setNews(response.data.data);
        } else if (response.data.status === Status.API_NO_CONTENT) {
          dispatch(errorSnackbar(response.data.message));
        } else {
          dispatch(errorSnackbar("Error while fetching News."));
        }
      })
      .catch((err) => {
        dispatch(stopLoading);
        dispatch(errorSnackbar("Error while fetching News."));
      });
  };

  return (
    <Box>
      <Box className="storySectionFabButton">
        <Fab
          className="storyFabButton"
          onClick={() => props.onPageChange(DrawerItemsKey.ADD_NEWS_SCREEN)}
        >
          <CreateIcon />
        </Fab>
      </Box>
      {news.map((newsItem) => (
        <Box>
          <Card className="storySectionCard">
            <Box>
              <img
                src={newsItem.imgUrl ?? placeholderBanner}
                className="storySectionImage"
                alt={newsItem.headline}
              />
            </Box>

            <Box className="storySectionDetails">
              <Typography className="storySectionHeadline">
                {newsItem.headline}
              </Typography>
              <Typography className="storySectionDescription">
                {newsItem.shortDescription}...
              </Typography>

              <Box className="storySectionBottom">
                <Box className="storySectionUserDetails">
                  <Avatar
                    name={`${newsItem.postedBy.firstName} ${newsItem.postedBy.lastName}`}
                    round={true}
                    size="45"
                  />
                  <Box className="storySectionPostedBy">
                    <p>Posted by</p>
                    <h5>{`${newsItem.postedBy.firstName} ${newsItem.postedBy.lastName}`}</h5>
                  </Box>
                </Box>
                <Button
                  variant="contained"
                  className="storySectionButton"
                  onClick={() =>
                    props.onPageChange(DrawerItemsKey.NEWS_DETAILS_SCREEN, {
                      _id: newsItem._id,
                    })
                  }
                >
                  read full news
                </Button>
              </Box>
            </Box>
          </Card>
        </Box>
      ))}
    </Box>
  );
};

export default News;
